// Reusable Loader Component matching the website theme

// Full Page Loader
export const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="text-center">
      {/* Modern minimalist loader */}
      <div className="relative w-20 h-20 mx-auto mb-8">
        {/* Outer spinning ring */}
        <div className="absolute inset-0 border-4 border-gray-100 rounded-full"></div>
        <div className="absolute inset-0 border-4 border-transparent border-t-black rounded-full animate-spin"></div>

        {/* Inner logo/icon */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 bg-black rounded-lg flex items-center justify-center text-white font-bold text-xs">
            SB
          </div>
        </div>
      </div>

      {/* Loading text */}
      <h2 className="text-xl font-semibold text-gray-900">
        Loading
      </h2>
    </div>
  </div>
);

// Inline Spinner (for buttons)
export const Spinner = ({ size = 'md', color = 'white' }) => {
  const sizeClasses = {
    sm: 'w-3 h-3 border-2',
    md: 'w-4 h-4 border-2',
    lg: 'w-5 h-5 border-2'
  };

  const colorClasses = {
    white: 'border-white/30 border-t-white',
    black: 'border-gray-200 border-t-black',
    red: 'border-red-200 border-t-red-600'
  };

  return (
    <div className={`${sizeClasses[size]} ${colorClasses[color]} rounded-full animate-spin`}></div>
  );
};

export default PageLoader;
